import z from "zod";

/**
 * Wrap a schema to accept `null` and treat it as `undefined`, and make it optional.
 * Usage: `nullableToOptional(z.string())` is equivalent to `z.preprocess(v => v === null ? undefined : v, z.string()).optional()`
 */
export const nullableToOptional = <T extends z.ZodTypeAny>(schema: T) =>
  z.preprocess((v) => (v === null ? undefined : v), schema.optional());
